module.exports = __webpack_public_path__ + "img/frame (36).fbac7482.jpg";